import { Edit } from "react-feather"
import { Card } from "@/components/ui/card"

interface NoteSectionProps {
  title: string
  content?: string
  defaultContent?: string
  onEditClick?: () => void
  showEditIcon?: boolean
}

export function NoteSection({
  title,
  content,
  defaultContent = "注意事項はありません",
  onEditClick,
  showEditIcon = false,
}: NoteSectionProps) {
  return (
    <Card className="p-0">
      <div className="bg-slate-100 border-b px-4 py-2 flex items-center justify-between">
        <span className="text-sm font-medium">{title}</span>
        <div className="flex gap-2">
          {showEditIcon && (
            <Edit
              size={14}
              className="text-primary cursor-pointer hover:text-gray-600"
              onClick={onEditClick}
            />
          )}
        </div>
      </div>
      <div className="p-4">
        <p className="text-sm text-gray-600 line-clamp-2">{content || defaultContent}</p>
      </div>
    </Card>
  )
}
